module.exports = __webpack_public_path__ + "static/media/bgTopCategory.01a40ee1.svg";